import React from 'react'
import StepperFrame from '../components/common/stepper/StepperFrame'
import "../components/common/stepper/Stepper.css"
import "../App.css";

import AhelyS from '../assets/images/speakers/headshots/AhelyS.jpg'

// New headshots
import AdamPerron from '../assets/images/speakers/new_headshots/AdamPerron.jpeg'
import AkinShonibare from '../assets/images/speakers/new_headshots/AkinShonibare.jpeg'
import ArjunVegda from '../assets/images/speakers/new_headshots/ArjunVegda.jpg'
import DerekGrossman from '../assets/images/speakers/new_headshots/DerekGrossman.jpg'
import EmilyMendelson from '../assets/images/speakers/new_headshots/EmilyMendelson.jpg'
import ErinGallagher from '../assets/images/speakers/new_headshots/ErinGallagher.jpg'
import GarretCree from '../assets/images/speakers/new_headshots/GarretCree.jpg'
import GraceMa from '../assets/images/speakers/new_headshots/GraceMa.jpg'
import JenniferGoetz from '../assets/images/speakers/new_headshots/JenniferGoetz.jpeg'
import JohnGao from '../assets/images/speakers/new_headshots/JohnGao.jpeg'
import LoreinaChew from '../assets/images/speakers/new_headshots/LoreinaChew.jpg'
import MichaelLam from '../assets/images/speakers/new_headshots/MichaelLam.jpeg'
import MonicaStewart from '../assets/images/speakers/new_headshots/MonicaStuart.jpeg'
import NadiaLe from '../assets/images/speakers/new_headshots/NadiaLe.jpg'
import NicolaSalimova from '../assets/images/speakers/new_headshots/NicolaSalimova.jpg'
import NishantBhasin from '../assets/images/speakers/new_headshots/NishantBhasin.jpg'
import ReneeVettivelu from '../assets/images/speakers/new_headshots/ReneeVettivelu.jpg'
import RobertSaunders from '../assets/images/speakers/new_headshots/RobertSaunders.jpg'
import VictorUemura from '../assets/images/speakers/new_headshots/VictorUemura.jpeg'
import WennieWu from '../assets/images/speakers/new_headshots/WennieWu.png'
import ZackeryHarley from '../assets/images/speakers/new_headshots/ZackeryHarley.jpg'
import PremRaval from '../assets/images/speakers/new_headshots/PremRaval.jpg'

import MichaelJudd from '../assets/images/speakers/new_headshots/MichaelJudd.jpeg'
import EmilyBao from '../assets/images/speakers/new_headshots/EmilyBao.jpg'
import PrimroseChareka from '../assets/images/speakers/new_headshots/PrimroseChareka.jfif'
import FrancescoVirga from '../assets/images/speakers/new_headshots/FrancescoVirga.png'
import ArpitaKar from '../assets/images/speakers/new_headshots/ArpitaKar.jpg'
import ChloeBeisheim from '../assets/images/speakers/new_headshots/ChloeBeisheim.JPG'
import LauraMacDonald from '../assets/images/speakers/new_headshots/LauraMacDonald.jpg'
import KatieIvancic from '../assets/images/speakers/new_headshots/KatieIvancic.jpg'
import NeveRyan from '../assets/images/speakers/new_headshots/NeveRyan.jpg'
import GaliciaGordon from '../assets/images/speakers/new_headshots/GaliciaGordon.jpg'
import MichaelStolls from '../assets/images/speakers/new_headshots/MichaelStolls.jpg'
import RavinaAnand from '../assets/images/speakers/new_headshots/RavinaAnand.jpg'
import GregBavington from '../assets/images/speakers/new_headshots/GregBavington.jpg'
import DavidHariri from '../assets/images/speakers/new_headshots/DavidHariri.jpg'
import CatherineJohnson from '../assets/images/speakers/new_headshots/CatherineJohnson.jpg'
import KylaNorris from '../assets/images/speakers/new_headshots/KylaNorris.jpg'
import CaitlinSabean from '../assets/images/speakers/new_headshots/CaitlinSabean.jpg'
import ChaojunSu from '../assets/images/speakers/new_headshots/ChaojunSu.jpg'

import SmileCDR from '../assets/images/2022_sponsors/smileCDR.png'
import Scotia from '../assets/images/2022_sponsors/scotiabank.jpg'
import Google from "../assets/images/2022_sponsors/google.png";
import Bounce from "../assets/images/2022_sponsors/bounce.png";
import DDQIC from "../assets/images/2022_sponsors/ddqic.jpg";
import Wealthsimple from "../assets/images/2022_sponsors/wealthsimple.png";
import Bell from "../assets/images/2022_sponsors/bell.png";
import DoorDash from "../assets/images/2022_sponsors/doordash.png";
import Mozilla from "../assets/images/2022_sponsors/mozilla.png";
import Microsoft from "../assets/images/2022_sponsors/microsoft.png";
import Gameloft from "../assets/images/2022_sponsors/gameloft.jpg";
import LeadingLearners from "../assets/images/2022_sponsors/leadinglearners.png";
import Uber from "../assets/images/2022_sponsors/uber.png";
import STAN from "../assets/images/2022_sponsors/stan.png";
import GlobalNews from "../assets/images/2022_sponsors/globalnews.png";
import Shopify from "../assets/images/2022_sponsors/shopify.png";
import Deloitte from "../assets/images/2022_sponsors/deloitte.png";
import Accenture from "../assets/images/2022_sponsors/accenture.png";
import Konrad from "../assets/images/2022_sponsors/konrad.jpg";
import BMO from "../assets/images/2022_sponsors/bmo.png";
import Coursera from "../assets/images/2022_sponsors/coursera.png";
import Facebook from "../assets/images/2022_sponsors/facebook.jpg";
import Koho from "../assets/images/2022_sponsors/koho.png";
import Skillful from "../assets/images/2022_sponsors/skillful.svg";
import Mars from "../assets/images/2022_sponsors/mars.png";
import Twillo from "../assets/images/2022_sponsors/twillo.png";
import IBM from "../assets/images/2022_sponsors/ibm.png";
import Aws from "../assets/images/2022_sponsors/aws.png";
import Ada from "../assets/images/2022_sponsors/ada.svg";
import Flik from "../assets/images/2022_sponsors/flik.png";
import Slalom from '../assets/images/2022_sponsors/slalom.png'


const Fireside = [
    [  
        {picture: DavidHariri,  name:"David Hariri", position:"Co-Founder", company:Ada, logoW:"200px", logoH:"40px", logoM:"12px 0px 0px 0px" },
        {picture: RavinaAnand,  name:"Ravina Anand", position:"Co-Founder", company:Flik, logoW:"60px", logoH:"60px", logoM:"0px 0px 0px 0px"},
        {picture: GregBavington,  name:"Greg Bavington", position:"Executive Director", company:DDQIC, logoW:"105px", logoH:"60px", logoM:"5px 0px 0px 0px"}
    ]
];

const ResumeRoast = [
    [  
        {picture: KylaNorris,  name:"Kyla Norris", position:"Recruiter", company:Slalom, logoW:"auto", logoH:"30px", logoM:"10px 0px 0px 0px" },
        {picture: CatherineJohnson,  name:"Catherine Johnson", position:"Talent Acquisition Sr Manager", company:Slalom, logoW:"auto", logoH:"30px", logoM:"10px 0px 0px 0px"}
        // {picture: GregBavington,  name:"Greg Bavington", position:"Executive Director", company:DDQIC, logoW:"200px", logoH:"40px", logoM:"10px 0px 0px 0px"}
    ]
];
const Recent_grads = [
     [  
         {picture: MichaelJudd,  name:"Michael Judd", position:"Senior Software Engineer", company:Wealthsimple, logoW:"210px", logoH:"30px", logoM:"15px 0px" },
         {picture: EmilyBao,  name:"Emily Bao", position:"Technical Analyst", company:Scotia, logoW:"200px", logoH:"40px", logoM:"10px 0px 0px 0px"},
         {picture: PrimroseChareka,  name:"Primrose Chareka", position:"Software Engineer", company:Google, logoW:"150px", logoH:"50px", logoM:"10px 0px 0px 0px"},
         {picture: FrancescoVirga,  name:"Francesco Virga", position:"Co-Founder & CTO", company:Bounce, logoW:"220px", logoH:"50px", logoM:"0px 0px 0px 0px"},
         {picture: ArpitaKar,  name:"Arpita Kar", position:"Data Scientist", company:Bell, logoW:"79px", logoH:"45px", logoM:"0px 0px 0px 0px"},
         {picture: ChloeBeisheim,  name:"Chloe Beisheim", position:"Outreach Manager", company:DDQIC, logoW:"105px", logoH:"60px", logoM:"0px 0px 0px 0px"},
     ]
];

const Scotia_Howto = [
    [  //Women in STEMs
        {picture: LauraMacDonald,  name:"Laura MacDonald", position:"Campus Recruiter - Technology", company:Scotia, logoW:"200px", logoH:"40px", logoM:"10px 0px 0px 0px" },
        {picture: KatieIvancic,  name:"Katie Ivancic", position:"Campus Recruiter - Technology", company:Scotia, logoW:"200px", logoH:"40px", logoM:"10px 0px 0px 0px"},
        {picture: NeveRyan,  name:"Neve Ryan", position:"Campus Recruiter - Technology", company:Scotia, logoW:"200px", logoH:"40px", logoM:"10px 0px 0px 0px"}
    ]
];

const CombinedWorkshops = [
    [  //Women in STEMs
        {picture: GaliciaGordon,  name:"Galicia Gordon", position:"Founder at Leading Learners", company:LeadingLearners, logoW:"200px", logoH:"40px", logoM:"10px 0px 0px 0px" },
        {picture: KatieIvancic,  name:"Katie Ivancic", position:"Campus Recruiter - Technology", company:Scotia, logoW:"200px", logoH:"40px", logoM:"11px 0px 0px 0px"},
        {picture: CatherineJohnson,  name:"Catherine Johnson", position:"Talent Acquisition Sr Manager", company:Slalom, logoW:"auto", logoH:"30px", logoM:"10px 0px 0px 0px"},
        {picture: NeveRyan,  name:"Neve Ryan", position:"Campus Recruiter - Technology", company:Scotia, logoW:"200px", logoH:"40px", logoM:"11px 0px 0px 0px"},
        {picture: CaitlinSabean,  name:"Caitlin Sabean-Untermann", position:"Talent Acquisition Specialist", company:SmileCDR, logoW:"156px", logoH:"40px", logoM:"0px 0px 0px 0px", posminH:"30px" },
        {picture: MichaelStolls,  name:"Michael Stolls", position:"Studio Manager of Gameloft Toronto", company:Gameloft, logoW:"75px", logoH:"52px", logoM:"10px 0px 0px 0px" },

    ],
    [
        {picture: KylaNorris,  name:"Kyla Norris", position:"Talent Acquisition Manager", company:Slalom, logoW:"auto", logoH:"30px", logoM:"10px 0px 0px 0px" },
        {picture: LauraMacDonald,  name:"Laura MacDonald", position:"Campus Recruiter - Technology", company:Scotia, logoW:"200px", logoH:"40px", logoM:"10px 0px 0px 0px" },
        {picture: ChaojunSu,  name:"Chaojun Su", position:"Talent Acquisition Specialist", company:SmileCDR, logoW:"156px", logoH:"40px", logoM:"8px 0px 0px 0px" },
    ]
];

const LeadingWork = [
    [  //Women in STEMs
        {picture: GaliciaGordon,  name:"Galicia Gordon", position:"Founder at Leading Learners", company:LeadingLearners, logoW:"200px", logoH:"40px", logoM:"10px 0px 0px 0px" },
        // {picture: KatieIvancic,  name:"Katie Ivancic", position:"Campus Recruiter - Technology", company:Scotia, logoW:"200px", logoH:"40px", logoM:"10px 0px 0px 0px"},
        // {picture: NeveRyan,  name:"Neve Ryan", position:"Campus Recruiter - Technology", company:Scotia, logoW:"200px", logoH:"40px", logoM:"10px 0px 0px 0px"}
    ]
];

const SmileWork = [
    [  //Women in STEMs
        {picture: CaitlinSabean,  name:"Caitlin Sabean-Untermann", position:"Talent Acquisition Specialist", company:SmileCDR, logoW:"200px", logoH:"40px", logoM:"10px 0px 0px 0px" },
        {picture: ChaojunSu,  name:"Chaojun Su", position:"Talent Acquisition Specialist", company:SmileCDR, logoW:"200px", logoH:"40px", logoM:"10px 0px 0px 0px" }
    ]
];

const GameloftWork = [
    [  //Women in STEMs
        {picture: MichaelStolls,  name:"Michael Stolls", position:"Studio Manager of Gameloft Toronto", company:Gameloft, logoW:"75px", logoH:"52px", logoM:"10px 0px 0px 0px" }
        // {picture: KatieIvancic,  name:"Katie Ivancic", position:"Campus Recruiter - Technology", company:Scotia, logoW:"200px", logoH:"40px", logoM:"10px 0px 0px 0px"},
        // {picture: NeveRyan,  name:"Neve Ryan", position:"Campus Recruiter - Technology", company:Scotia, logoW:"200px", logoH:"40px", logoM:"10px 0px 0px 0px"}
    ]
];




const Mentors = [
    [  
       {picture: ArjunVegda,  name:"Arjun Vegda", position:"Software Engineer", company:DoorDash, logoW:"188px", logoH:"22px", logoM:"15px 0px 0px"},
       {picture: NishantBhasin,  name:"Nishant Bhasin", position:"Senior Software Engineer", company:Mozilla, logoW:"134px", logoH:"35px", logoM:"5px 0px 0px 0px"},
       {picture: MichaelLam,  name:"Michael Lam", position:"Software Engineer", company:Microsoft, logoW:"155px", logoH:"35px", logoM:"10px 0px 0px"},
       {picture: ErinGallagher,  name:"Erin Gallagher", position:"Software Engineer", company:Uber, logoW:"125px", logoH:"80px", logoM:"-15px 0px 0px"},
       {picture: NadiaLe,  name:"Nadia Le", position:"UX Designer", company:GlobalNews, logoW:"86px", logoH:"48px", logoM:"5px 0px 0px 0px"},
       {picture: GarretCree,  name:"Garret Cree", position:"Data Analytics Lead", company:Mars, logoW:"65px", logoH:"65px", logoM:"0px 0px 0px 0px"}

    ],
    [  
        {picture: EmilyMendelson,  name:"Emily Mendelson", position:"Business Technology Analyst", company:Deloitte, logoW:"161px", logoH:"30px", logoM:"15px 0px 0px"},
        {picture: RobertSaunders,  name:"Robert Saunders", position:"Sr Software Engineer", company:Shopify, logoW:"158px", logoH:"45px", logoM:"5px 0px 0px 0px"},
        {picture: PremRaval ,  name:"Prem Raval", position:"Software Engineer", company:STAN, logoW:"131px", logoH:"52px", logoM:"5px 0px 0px 0px"},
        {picture: MonicaStewart,  name:"Monica Stewart", position:"Associate Software Developer", company:Konrad, logoW:"185px", logoH:"32px", logoM:"15px 0px 0px 0px"},
        {picture: AdamPerron,  name:"Adam Perron", position:"Staff Product Designer", company:Shopify, logoW:"158px", logoH:"45px", logoM:"5px 0px 0px 0px"},
        {picture: ReneeVettivelu,  name:"Renee Vettivelu", position:"Business Analyst", company:BMO, logoW:"134px", logoH:"46px", logoM:"7px 0px 0px 0px"}
    ],
    [  
        {picture: JohnGao,  name:"John Gao", position:"Data Engineer", company:Coursera, logoW:"171px", logoH:"25px", logoM:"15px 0px 0px"},
        {picture: GraceMa,  name:"Grace Ma", position:"Product Designer", company:Facebook, logoW:"130px", logoH:"45px", logoM:"5px 0px 0px 0px"},
        {picture: JenniferGoetz ,  name:"Jennifer Goetz", position:"Software Engineer", company:Koho, logoW:"153px", logoH:"45px", logoM:"5px 0px 0px 0px"},
        {picture: AkinShonibare,  name:"Akin Shonibare", position:"Software Engineer", company:Shopify, logoW:"158px", logoH:"45px", logoM:"0px 0px 0px 0px"},
        {picture: ZackeryHarley,  name:"Zackery Harley", position:"Founding Engineering Lead", company:Skillful, logoW:"127px", logoH:"37px", logoM:"5px 0px 0px"},
        {picture: LoreinaChew,  name:"Loreina Chew", position:"Product Designer II", company:Twillo, logoW:"150px", logoH:"45px", logoM:"0px 0px 0px 0px"}
    ],
    [  
        {picture: NicolaSalimova,  name:"Nicola Salimova", position:"Business Transformation Associate", company:IBM, logoW:"92px", logoH:"37px", logoM:"22px 0px 0px"},
        {picture: WennieWu,  name:"Wennie Wu", position:"Data Scientist", company:Shopify, logoW:"158px", logoH:"45px", logoM:"15px 0px 0px 0px"},
        {picture: DerekGrossman,  name:"Derek Grossman", position:"DevOps Engineering", company:Accenture, logoW:"160px", logoH:"90px", logoM:"0px 0px"},
        {picture: VictorUemura ,  name:"Victor Uemura", position:"Software Development Engineer", company:Aws, logoW:"81px", logoH:"48px", logoM:"16px 0px 0px 0px"}
    ]
];








const Speaker = () => {
    return (
        <div className="PageContainer sidePadding">
            <h1 className="PageHeader" >Our 2022 Speakers</h1>
            
            <StepperFrame minh="490px" cards={Fireside} stepperTitle="Fireside Chat - Entrepreneurship: A Winding Road to Success" />
            <StepperFrame cards={Recent_grads} stepperTitle="Panel - Recent Graduates Unfiltered" />
            <StepperFrame cards={CombinedWorkshops} stepperTitle="Workshop Leaders" />
            <StepperFrame cards={Mentors} stepperTitle="Mentors" />
            
            {/* <StepperFrame cards = {MentorsandLeaders} stepperTitle="Additional Mentors and Workshop Leaders" /> */}

            
        </div>
    )
}
export default Speaker
